import { render, staticRenderFns } from "./ChatEventUser.vue?vue&type=template&id=107d8290&"
import script from "./ChatEventUser.vue?vue&type=script&lang=js&"
export * from "./ChatEventUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports